import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BrightnessAutoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"brightness_auto"}/>
}
